import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { HelmetProvider, Helmet } from 'react-helmet-async';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { AuthProvider } from './AuthContext';
import { CartProvider } from './context/CartContext';
import { organizationLd, websiteLd } from './config/site';
import ErrorBoundary from './components/ErrorBoundary';

import Navbar from './components/fancyplants/Navbar';
import SiteFooter from './components/fancyplants/SiteFooter';
import CartDrawer from './components/fancyplants/CartDrawer';
import CookieBanner from './components/CookieBanner';

import HomePage from './pages/fp/HomePage';
import ShopPage from './pages/fp/ShopPage';
import ProductPage from './pages/fp/ProductPage';
import CareLibraryPage from './pages/fp/CareLibraryPage';
import CareGuidePage from './pages/fp/CareGuidePage';
import JournalPage from './pages/fp/JournalPage';
import JournalPostPage from './pages/fp/JournalPostPage';
import AboutPage from './pages/fp/AboutPage';
import VisitPage from './pages/fp/VisitPage';
import GiftCardsPage from './pages/fp/GiftCardsPage';
import CheckoutPage from './pages/fp/CheckoutPage';
import OrderConfirmedPage from './pages/fp/OrderConfirmedPage';
import NotFoundPage from './pages/fp/NotFoundPage';

import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import ProfilePage from './pages/ProfilePage';
import ProtectedRoute from './components/ProtectedRoute';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import CookiesNotice from './pages/CookiesNotice';

function App() {
  return (
    <HelmetProvider>
      <ErrorBoundary>
        <AuthProvider>
          <CartProvider>
            <Router>
              <Helmet>
                <script type="application/ld+json">
                  {JSON.stringify([organizationLd, websiteLd])}
                </script>
              </Helmet>
              <Navbar />
              <CartDrawer />
            <main className="min-h-screen">
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/shop" element={<ShopPage />} />
                <Route path="/shop/:slug" element={<ProductPage />} />
                <Route path="/care" element={<CareLibraryPage />} />
                <Route path="/care/:slug" element={<CareGuidePage />} />
                <Route path="/journal" element={<JournalPage />} />
                <Route path="/journal/:slug" element={<JournalPostPage />} />
                <Route path="/about" element={<AboutPage />} />
                <Route path="/visit" element={<VisitPage />} />
                <Route path="/gift-cards" element={<GiftCardsPage />} />
                <Route path="/checkout" element={<CheckoutPage />} />
                <Route path="/order-confirmed" element={<OrderConfirmedPage />} />

                <Route path="/login" element={<LoginPage />} />
                <Route path="/register" element={<RegisterPage />} />
                <Route path="/account" element={<ProtectedRoute><ProfilePage /></ProtectedRoute>} />
                <Route path="/profile" element={<ProtectedRoute><ProfilePage /></ProtectedRoute>} />

                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                <Route path="/terms-of-service" element={<TermsOfService />} />
                <Route path="/cookies-notice" element={<CookiesNotice />} />

                <Route path="*" element={<NotFoundPage />} />
              </Routes>
            </main>
            <SiteFooter />
            <CookieBanner />
            <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} />
            </Router>
          </CartProvider>
        </AuthProvider>
      </ErrorBoundary>
    </HelmetProvider>
  );
}

export default App;
